import { router, Stack, usePathname } from 'expo-router';
import { Platform } from 'react-native';
import { useStyles } from 'react-native-unistyles';

import BackButton from '@/components/back-button';
import { isDesktop } from '@/core';

export default function HomeLayout() {
  const { theme } = useStyles();
  const pathname = usePathname();

  return (
    <Stack
      screenOptions={{
        headerShown: pathname === '/account',
        headerTitle: 'Account',
        title: 'Account',
        headerTitleAlign: 'center',
        contentStyle: {
          backgroundColor: theme.colors.background_1,
        },
        headerStyle: {
          backgroundColor: theme.colors.background_1,
        },
        headerTintColor: theme.colors.text.primary,
        headerShadowVisible: false,
        headerLeft: () => null,
        headerBackVisible: false,
      }}
    >
      {Platform.OS === 'web' && isDesktop() ? (
        <Stack.Screen
          name="profile"
          options={{
            headerShown: false,
          }}
        />
      ) : (
        <Stack.Screen
          name="profile"
          options={{
            headerShown: false,
          }}
        />
      )}

      {Platform.OS === 'web' && isDesktop() ? (
        <Stack.Screen
          name="support-faq"
          options={{
            headerShown: false,
          }}
        />
      ) : (
        <Stack.Screen
          name="support-faq/index"
          options={{
            title: 'Support',
            headerTitle: 'Support',
            headerLeft: () => (
              <BackButton
                onPress={() => {
                  if (Platform.OS === 'android' && router.canDismiss()) {
                    router.dismiss();
                  }

                  router.navigate('/account');
                }}
              />
            ),
            headerShown: true,
            headerStyle: {
              backgroundColor: theme.colors.background_1,
            },
            headerTintColor: theme.colors.text.primary,
            headerShadowVisible: false,
          }}
        />
      )}

      {Platform.OS === 'web' && isDesktop() ? (
        <Stack.Screen
          name="referrals"
          options={{
            headerShown: false,
          }}
        />
      ) : (
        <Stack.Screen
          name="referrals"
          options={{
            title: 'Referral',
            headerTitle: 'Referral',
            headerLeft: () => <BackButton />,
            headerShown: true,
            headerStyle: {
              backgroundColor: theme.colors.background_1,
            },
            headerTintColor: theme.colors.text.primary,
            headerShadowVisible: false,
          }}
        />
      )}

      {Platform.OS === 'web' && isDesktop() ? (
        <Stack.Screen
          name="legal"
          options={{
            headerShown: false,
          }}
        />
      ) : (
        <Stack.Screen
          name="legal/index"
          options={{
            title: 'Legal',
            headerTitle: 'Legal',
            headerLeft: () => (
              <BackButton
                onPress={() => {
                  if (Platform.OS === 'android' && router.canDismiss()) {
                    router.dismiss();
                  }

                  router.navigate('/account');
                }}
              />
            ),
            headerShown: true,
            headerStyle: {
              backgroundColor: theme.colors.background_1,
            },
            headerTintColor: theme.colors.text.primary,
            headerShadowVisible: false,
          }}
        />
      )}

      {Platform.OS === 'web' && isDesktop() ? (
        <Stack.Screen
          name="forgot-password"
          options={{
            headerShown: false,
          }}
        />
      ) : (
        <Stack.Screen
          name="forgot-password"
          options={{
            title: 'Forgot Password',
            headerTitle: 'Forgot Password',
            headerLeft: () => <BackButton />,
            headerShown: false,
            headerStyle: {
              backgroundColor: theme.colors.background_1,
            },
            headerTintColor: theme.colors.text.primary,
            headerShadowVisible: false,
          }}
        />
      )}

      <Stack.Screen
        name="confirm-phone"
        options={{
          title: 'Phone Number',
          headerShown: false,
        }}
      />

      {Platform.OS === 'web' && isDesktop() ? (
        <Stack.Screen
          name="trip-history/index"
          options={{
            headerShown: false,
          }}
        />
      ) : (
        <Stack.Screen
          name="trip-history/index"
          options={{
            title: 'Receipts',
            headerTitle: 'Receipts',
            headerLeft: () => <BackButton />,
            headerShown: true,
          }}
        />
      )}

      {Platform.OS === 'web' && isDesktop() ? (
        <Stack.Screen
          name="trip-history/[id]/index"
          options={{ headerShown: false }}
        />
      ) : (
        <Stack.Screen
          name="trip-history/[id]/index"
          options={{
            title: '',
            headerTitle: '',
            headerShown: true,
            headerLeft: () => <BackButton />,
          }}
        />
      )}

      {Platform.OS === 'web' && isDesktop() ? (
        <Stack.Screen
          name="trip-history/incidentals/index"
          options={{ headerShown: false }}
        />
      ) : (
        <Stack.Screen
          name="trip-history/incidentals/index"
          options={{
            title: '',
            headerTitle: '',
            headerShown: true,
            headerLeft: () => <BackButton />,
          }}
        />
      )}

      {Platform.OS === 'web' && isDesktop() ? (
        <Stack.Screen
          name="trip-history/[id]/incidentals/[inc_id]/index"
          options={{ headerShown: false }}
        />
      ) : (
        <Stack.Screen
          name="trip-history/[id]/incidentals/[inc_id]/index"
          options={{
            title: '',
            headerTitle: '',
            headerShown: true,
            headerTitleAlign: 'center',
            headerLeft: () => <BackButton />,
          }}
        />
      )}
    </Stack>
  );
}
